<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Assign Phone Number to RedChirp User</v-card-title>

    <v-card-text>
        
        <v-stepper
            v-model="step"
            vertical
        >

        <v-stepper-step
            :complete="step > 1"
            step="1"
        >
            Choose User
            <small v-if="step > 1">{{selected_team_member.text}}</small>
        </v-stepper-step>

        <v-stepper-content step="1">

            Choose a RedChirp user to assign {{endpoint_pretty_print}} to:
            <v-select
                :items="team_members"
                return-object
                v-model="selected_team_member"
                v-on:change="onChangeSelectedTeamMember"
            />

            <div style="margin-bottom: 15px;">
                <v-btn
                    :disabled="selected_team_member == null"
                    color="primary"
                    v-on:click="step = 2"
                >
                    Continue
                </v-btn>

                <v-btn
                    v-on:click="dialog = false"
                    style="margin-left: 15px;"
                >
                    Cancel
                </v-btn>
            </div>

        </v-stepper-content>

        <v-stepper-step
            :complete="step > 2"
            step="2"
        >
            Home Number
            <small v-if="step > 2">Make home number: {{make_home_number ? 'Yes' : 'No'}}</small>
        </v-stepper-step>

        <v-stepper-content step="2">

            <v-radio-group v-model="make_home_number" v-if="selected_team_member != null">
                <v-radio
                    :label="`Make this number ${selected_team_member.label_only}'s new home number`"
                    :value="true"
                ></v-radio>
                <v-radio
                    :label="`Leave ${selected_team_member.label_only}'s home number unchanged`"
                    :value="false"
                ></v-radio>
            </v-radio-group>

            <div style="margin-bottom: 15px;">
                <v-btn
                    :disabled="make_home_number == null"
                    color="primary"
                    v-on:click="step = 3"
                >
                    Continue
                </v-btn>

                <v-btn
                    v-on:click="dialog = false"
                    style="margin-left: 15px;"
                >
                    Cancel
                </v-btn>
            </div>

        </v-stepper-content>

        <v-stepper-step
            :complete="step > 3 "
            step="3"
        >
            Customize Label
            <small v-if="step > 3">{{custom_label}}</small>
        </v-stepper-step>

        <v-stepper-content step="3">
            <p>The label, and only the label, is visible to everyone in your organization when they view or search for this number.</p>

            <p><i>Most of the time</i>, when a phone number is assigned to a user, the label should be the user's name.</p>
            <p>If you would like to customize the new label for this phone number, you can do so here.</p>

            <v-text-field
                label="Custom Phone Number Label"
                v-model="custom_label"
                autocomplete="off"
            />

            <div style="margin-bottom: 15px;">
                <v-btn
                    :disabled="custom_label == null || custom_label.trim().length == 0"
                    color="primary"
                    v-on:click="step = 4"
                >
                    Continue
                </v-btn>

                <v-btn
                    v-on:click="dialog = false"
                    style="margin-left: 15px;"
                >
                    Cancel
                </v-btn>
            </div>

        </v-stepper-content>

        <v-stepper-step
            :complete="step > 3"
            step="4"
        >
            Assign Number
        </v-stepper-step>

        <v-stepper-content step="4">
            
            <div v-if="selected_team_member != null">
                <b>Phone Number: </b> {{endpoint_pretty_print}}<br/>
                <b>Assign To: </b> {{selected_team_member.text}}<br/>
                <b>Make home number: </b> {{make_home_number ? 'Yes' : 'No'}}<br/>
                <b>Label: </b> {{custom_label}}<br/>
            </div>

            <div style="margin-bottom: 15px; margin-top: 15px;">
                <v-btn
                    color="primary"
                    v-on:click="onOk"
                >
                    Assign Number
                </v-btn>

                <v-btn
                    v-on:click="dialog = false"
                    style="margin-left: 15px;"
                >
                    Cancel
                </v-btn>
            </div>

        </v-stepper-content>

        </v-stepper>



        

    </v-card-text>

    
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {

    data() {
        return {
            dialog: false,
            
            endpoint: '',
            endpoint_pretty_print: '',
            team_members: [],
            selected_team_member: null,
            custom_label: null,
            step: 1,
            make_home_number: false,
        }
    },

    methods: {
        showDialog(endpoint, team_members, current_assignment) 
        {
            this.step = 1;
            this.make_home_number = null;
            this.selected_team_member = null;

            this.endpoint = endpoint;
            this.endpoint_pretty_print = E164.prettyPrintUsPhoneNumber(endpoint);
            this.team_members = [];    

            this.custom_label = null;

            for ( let i = 0; i < team_members.length; i++ )
            {
                if ( team_members[i].is_archived )
                    continue;

                let obj = {
                    'text' : team_members[i].label+' - '+team_members[i].username,
                    'value' : team_members[i].employee_id,
                    'label_only' : team_members[i].label,
                };

                this.team_members.push(obj);
            }


            this.dialog = true;
        },

        onChangeSelectedTeamMember(new_team_member)
        {
            if ( new_team_member == null ) 
            {
                this.custom_label = null;
                return;
            }

            this.custom_label = new_team_member.label_only;
        },
        
        onOk()
        {
           this.dialog = false;
            
            let changes = {
                'endpoint' : this.endpoint,
                'assignment' : 'assigned-to-employee',
                'assigned_to_employee_id' : this.selected_team_member.value,
                'label' : this.custom_label,
            };

            if ( this.make_home_number )
            {
                changes.override_home_for_employee_id = this.selected_team_member.value;
            }

            this.$emit('ok', changes);
            return;
        },
    },
}
</script>

<style lang="scss" scoped>
.section_header {
    font-size: 20px; 
    font-weight: 700;
    margin-top: 15px;
    margin-bottom: 15px;
}
</style>